import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "19", cy: "19", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "5", cy: "5", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M5 7v12h12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m5 19 6-6", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Scale3d";
const Scale3d = memo(themed(Icon));
export {
  Scale3d
};
//# sourceMappingURL=scale-3d.js.map
